import { useLocation } from "react-router-dom";
import { RIBBON_BANNER_HEIGHT } from "../screens/root/constants";
import { useAccountData } from "./useAccountData";
import { useIsInReader } from "./useIsInReader";

export const RIBBON_SNOOZE_KEY = "ribbon_snoozed_until";

export function isRibbonSnoozed(): boolean {
  const snoozedUntil = localStorage.getItem(RIBBON_SNOOZE_KEY);
  if (!snoozedUntil) return false;

  const snoozedTime = parseInt(snoozedUntil, 10);
  const now = Date.now();

  if (now < snoozedTime) {
    return true;
  }

  // Clean up expired snooze
  localStorage.removeItem(RIBBON_SNOOZE_KEY);
  return false;
}

export function useShouldShowRibbon() {
  const accountData = useAccountData();
  const inReader = useIsInReader();
  const location = useLocation();

  const isGoldPage = location.pathname.includes("gold");
  const isHolidayBundlePage = location.pathname.includes("holiday-bundle-2025");
  const isBlackFridayGoldPageEnabled =
    accountData?.features["black_friday_deal"];
  const isHolidayBundlePageEnabled =
    accountData?.features["holiday_bundle"] && isHolidayBundlePage;
  const isBlackFridayDealPage = isGoldPage && isBlackFridayGoldPageEnabled;
 const isSettingsAccountPage =
   location.pathname.includes("settings") ||
   location.pathname.includes("settings/account");
  const hasRibbonContent = !!accountData?.ribbon?.content;

  return (
    hasRibbonContent &&
    !inReader &&
    !isBlackFridayDealPage &&
    !isHolidayBundlePageEnabled &&
    !isSettingsAccountPage &&
    !isRibbonSnoozed()
  );
}

export function useRibbonBannerHeight() {
  const shouldShowRibbon = useShouldShowRibbon();
  return shouldShowRibbon ? RIBBON_BANNER_HEIGHT : 0;
}
